import { identity } from 'rxjs';

/**
 * Contient les informations d'une colonne.
 */
export class Column {
	private readonly formatter: (value: any) => string;

	/**
	 * Constructeur.
	 *
	 * @param key le clé identifiant la colonne.
	 * @param header le titre de la colonne.
	 * @param formatter (optionnel) le formatter pour afficher les valeurs de la colonne.
	 */
	constructor(public key: string,
				public header: string,
				formatter?: (value: any) => string) {
		this.formatter = formatter ?? identity;
	}

	/**
	 * Formate la valeur donnée en paramètre selon le formatter de la colonne.
	 *
	 * @param value la valeur à formater.
	 */
	formatValue(value: any): string {
		return this.formatter(value);
	}
}
